import { SystemSubtypes } from '@fabric/woody-client';
import { useQueryResourceRootSpaceSystemList } from '../../spaces/queries/useQueryResourceRootSpaceSystemList.js';
import { useMemo } from 'react';

const useQueryInbox = () => {
  const { roots, isLoading } = useQueryResourceRootSpaceSystemList();
  const inboxRoot = useMemo(() => {
    return roots?.find((root) => root.type === "SYSTEM" && root.subtype === SystemSubtypes.INBOX);
  }, [
    roots
  ]);
  return {
    isLoading,
    inboxRoot
  };
};

export { useQueryInbox };
//# sourceMappingURL=useQueryInbox.js.map
